import propStyles from "./RevisarCadastro.module.css"; 
import { faBoxOpen, faFileCircleCheck, faFileSignature, faFileWaveform, faQuestion, faQuestionCircle, faUserTie } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import MenuIcon from "@mui/icons-material/Menu";
import { Alert, Box, CircularProgress, CssBaseline, FormControl, InputLabel, Menu, MenuItem, Modal, Snackbar, Toolbar, Tooltip } from "@mui/material"
import { AppBar, Drawer, DrawerHeader } from "../../components/Drawer/Drawer";
import DrawerButtonThatOpens from "../../components/Drawer/DrawerButton";
import ImagemLateralE from "../../assets/images/Lateral01.svg";
import ImagemLateralD from "../../assets/images/Lateral02.svg";
import { WhiteInput } from "../../components/Inputs/InputText";
import { useForm, Controller } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import servLogin from "../../services/login/servLogin";
import { useEffect, useState } from "react";
import { BlueHoverButton } from "../../components/Inputs/BlueHoverButton";
import { ImageInput } from "../../components/Inputs/ImageInput";
import { useGDSelector } from "../../hooks";
import { useDispatch } from "react-redux";
import { logout, solicitarHomolog } from "../../state/slices/userSlice";
import { style as modalStyle } from "../../components/Loading/Loading";
import { CriaArquivo } from "../../infra/utils/CriaArquivo";
import InputMask from "react-input-mask";
import { formatarTelefone, formatarCpf } from '../../infra/utils/FormataValores';
import { validarCpf } from '../../infra/utils/ValidacaoCpf';
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { HelperText } from "../../components/Errors/HelperText";
import { ModalStyle } from "../../components/Popup/ModalStyle";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import ptBR from "date-fns/locale/pt-BR";
import { parse } from "date-fns";

const schema = yup.object().shape({
    nome: yup.string().required("Este campo é obrigatório").matches("([A-Za-z]( )[A-Za-z]+)", "Deve conter nome e sobrenome (somente letras)").max(100, "Deve conter até 100 caracteres"), 
    celular: yup.string().required("Este campo é obrigatório"), 
    cpf: yup.string().required("Este campo é obrigatório").matches("([0-9]{2}[\.]?[0-9]{3}[\.]?[0-9]{3}[\/]?[0-9]{4}[-]?[0-9]{2})|([0-9]{3}[\.]?[0-9]{3}[\.]?[0-9]{3}[-]?[0-9]{2})", "CPF deve estar no formato correto"), 
    email: yup.string().email("O e-mail deve ser válido").required("Este campo é obrigatório").max(100, "Deve conter até 100 caracteres"),
    empresa: yup.string().required("Valor inválido. Este campo é obrigatório").max(100, "Deve conter até 100 caracteres"),
    creadoc: yup.string().required("Valor inválido. Este campo é obrigatório").matches(/^\d+$/, "Deve conter somente números").max(15, "Deve conter até 15 caracteres"),
    dataValidadeCrea: yup.date().nullable().typeError("Valor inválido.").min(new Date(), "Data de Validade deve ser maior que a data atual."),
});

const RevisarCadastro = () => {
    const [isLoading, setIsLoading] = useState(false);
    
    const [open, setOpen] = useState(false);
    const [openSuccess, setOpenSuccess] = useState(false);
    
    const [errorMessage, setErrorMessage] = useState("");
    const [successMessage, setSuccessMessage] = useState("");

    const [nomeCreaFrenteAux, setNomeCreaFrenteAux] = useState(null);
    const [nomeCreaVersoAux, setNomeCreaVersoAux] = useState(null);
    const [nomeFotoPessoalAux, setNomeFotoPessoalAux] = useState(null);
    const [creaFrenteAux, setCreaFrenteAux] = useState(null);
    const [creaVersoAux, setCreaVersoAux] = useState(null);
    const [fotoPessoalAux, setFotoPessoalAux] = useState(null);

    const [logoA, setLogoA] = useState(null);

    const [revisao, setRevisao] = useState("");
    const [openRevisao, setOpenRevisao] = useState(true);
    const [prazoAnaliseCadRespTec, setPrazoAnaliseCadRespTec] = useState(null);

    const [anchorEl, setAnchorEl] = useState(null);
    const openMenu = Boolean(anchorEl);

    const { register, control, handleSubmit, setValue, getValues, formState: { errors } } = useForm({ resolver: yupResolver(schema) });
    const user = useGDSelector(state => state.user);

    const navigate = useNavigate();
    const dispatch = useDispatch();

    useEffect(() => {
        try {
            const recuperarImagem = async () => {
                try {

                    const response = await servLogin.recuperarImages();
    
                    setLogoA(response.Content.UrlLogoAberta);
    
                } catch (err) {
                    console.log(err);
                }
            }

            const recuperarDados = async () => {
                setIsLoading(true);

                const response = await servLogin.recuperarDadosResponsavel(user.codigoUsuario),
                    data = response.Content;

                setValue("nome", data.Nome);
                setValue("celular", data.DddFone + data.Celular);
                setValue("email", data.Email);
                setValue("cpf", data.CPF);
                setValue("empresa", data.Empresa);
                setValue("creadoc", data.Crea);

                setValue("dataValidadeCrea", data.DataValidadeCrea != '01/01/1900 00:00:00' ? parse(data.DataValidadeCrea, 'dd/MM/yyyy HH:mm:ss', new Date()) : null);

                setCreaFrenteAux(data.CreaFrente);
                setNomeCreaFrenteAux(data.NomeCreaFrente);

                setCreaVersoAux(data.CreaVerso)
                setNomeCreaVersoAux(data.NomeCreaVerso);

                setFotoPessoalAux(data.FotoPessoal)
                setNomeFotoPessoalAux(data.NomeFotoPessoal);

                setIsLoading(false);
            }

            const recuperaDatasParametrizacao = async () => {
                setIsLoading(true);

                const data = await servLogin.consultaAnaliseResponsavel(user.codigoUsuario);
                
                setPrazoAnaliseCadRespTec(data.Content.PrazoAnaliseCadastroRespTec);

                setIsLoading(false);
            }

            const recuperarMotivoDeReprovacao = async () => {
                try {
                    const data = await servLogin.recuperarMotivoDeReprovacao(user.codigoUsuario);

                    setRevisao(data.Content.MotivoReprovacao);
                } catch (err) {
                    setIsLoading(false);
                    console.log(err.Message);
                }
            }

            const recuperarImagensDoResponsavelTec = async () => {
                try {
                    const response = await servLogin.recuperarImagensDoResponsavelTecnico(user.codigoUsuario);
                    
                    setCreaFrenteAux(response.Content.CreaFrente);
                    setCreaVersoAux(response.Content.CreaVerso);
                    setFotoPessoalAux(response.Content.FotoPessoal);
                    setNomeCreaFrenteAux(response.Content.NomeCreaFrente);
                    setNomeCreaVersoAux(response.Content.NomeCreaVerso);
                    setNomeFotoPessoalAux(response.Content.NomeFotoPessoal);
                } catch(err) {
                    console.log(err.Message);
                }
            }

            setIsLoading(true);

            recuperarImagem();

            recuperarMotivoDeReprovacao();

            recuperarDados();

            recuperarImagensDoResponsavelTec();

            recuperaDatasParametrizacao();

            setIsLoading(false);

        } catch (err) {
            setIsLoading(false);
            handleAlertError(err.response.data.Message);

            return;
        }
    }, []);

    const handleAlertSuccess = (message) => {
        setOpenSuccess(true);
        setSuccessMessage(message);
    }

    const handleAlertError = (message) => {
        setOpen(true);
        setErrorMessage(message);
    }

    const handleCloseSuccess = (event, reason) => {
        if (reason === 'clickaway') {
            setOpenSuccess(false);
        }

        setOpenSuccess(false);
    }

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            setOpen(false);
        }

        setOpen(false);
    }

    const createFormData = (data) => {
        const formData = new FormData();

        let creaFrente, creaVerso, fotoPessoal, creaFrenteNaoAlterado, creaVersoNaoAlterado, fotoPessoalNaoAlterado;

        if(data.frenteCrea[0] === undefined) {
            creaFrente = CriaArquivo(creaFrenteAux, nomeCreaFrenteAux);
            creaFrenteNaoAlterado = true;
        } else {
            creaFrente = data.frenteCrea[0];
        }

        if(data.versoCrea[0] === undefined) {
            creaVerso = CriaArquivo(creaVersoAux, nomeCreaVersoAux);
            creaVersoNaoAlterado = true;
        } else {
            creaVerso = data.versoCrea[0];
        }

        if(data.selfie[0] === undefined) {
            fotoPessoal = CriaArquivo(fotoPessoalAux, nomeFotoPessoalAux);
            fotoPessoalNaoAlterado = true;
        } else {
            fotoPessoal = data.selfie[0];
        }

        let cpf = formatarCpf(data.cpf);
        let celular = formatarTelefone(data.celular);
        let ddd = celular.slice(0, 2);
        celular = celular.slice(2);

        if(!validarCpf(cpf)) {
            setIsLoading(false);
            handleAlertError("O CPF informado é inexistente.");

            return false;
        }

        if(celular.length < 9) {
            setIsLoading(false);
            handleAlertError("O telefone informado é inválido.");

            return false;
        }

        formData.append("CreaFrenteB", creaFrenteAux);
        formData.append("NomeCreaFrente", nomeCreaFrenteAux);
        formData.append("CreaVersoB", creaVersoAux);
        formData.append("NomeCreaVerso", nomeCreaVersoAux);
        formData.append("FotoPessoalB", fotoPessoalAux);
        formData.append("NomeFotoPessoal", nomeFotoPessoalAux);
        formData.append("CreaFrente",  creaFrente);
        formData.append("CreaVerso",  creaVerso);
        formData.append("FotoPessoal", fotoPessoal);
        formData.append("CreaFrenteNaoAlterado", creaFrenteNaoAlterado);
        formData.append("CreaVersoNaoAlterado", creaVersoNaoAlterado);
        formData.append("FotoPessoalNaoAlterado", fotoPessoalNaoAlterado);

        formData.append("CodigoResponsavel", user.codigoUsuario);
        formData.append("Empresa", data.empresa);
        formData.append("Crea", data.creadoc);
        formData.append("Nome", data.nome);
        formData.append("Email", data.email);
        formData.append("Celular", celular);
        formData.append("CPF", cpf);
        formData.append("DddFone", ddd);
        formData.append("DataValidadeCrea", data.dataValidadeCrea ? formataDataValidade(data.dataValidadeCrea) : null);

        return formData;
    }

    const formataDataValidade = (dataValidade) => {
        dataValidade.setHours(0);
        dataValidade.setMinutes(0);
        dataValidade.setSeconds(0);
        dataValidade.setMilliseconds(0);

        return new Date(dataValidade).toJSON();
    }

    const onClickSolicitarNovaAnalise = handleSubmit ( async () => {
        const data = getValues();

        try {
            if (!data) return;

            const formData = createFormData(data);

            setIsLoading(true);

            if(!formData) {
                setIsLoading(false);

                return;
            }

            await servLogin.salvarEdicao(user.codigoUsuario, formData);

            await servLogin.solicitarNovaHomologacao(user.codigoUsuario);
            
            setIsLoading(false);
            handleAlertSuccess("Solicitação enviada com sucesso. Aguarde a aprovação do analista de projeto.");

            dispatch(solicitarHomolog());

            navigate("/aguardarCadastro");
        } catch (err) {
            setIsLoading(false);
            handleAlertError(err.response.data.Message);
            
            return;
        }
    })

    const onClickSalvarCad = handleSubmit ( async () => {
        const data = getValues();

        try {
            if (!data) return;
            
            const formData = createFormData(data);

            setIsLoading(true);

            if(!formData) {
                setIsLoading(false);

                return;
            }

            await servLogin.salvarEdicao(user.codigoUsuario, formData);
            
            setIsLoading(false);
            handleAlertSuccess("Registro atualizado com sucesso.");
        } catch (err) {
            setIsLoading(false);
            handleAlertError(err.response.data.Message);
            
            return;
        }
    });

    const onClickLogout = (e) => {
        dispatch(logout());
        navigate("/");
    }

    const handleCloseRevisao = () => {
        setOpenRevisao(false);
    }

    const handleClickMenu = (event) => {
        setAnchorEl(event.currentTarget);
    }

    const handleCloseMenu = () => {
        setAnchorEl(null);
    }

    const handleClickManual = () => {
        window.open('https://manuaisp3tec.useallcloud.com.br/', '_blank', 'noopener,noreferrer');
    }

    return (
        <Box>
            <CssBaseline />    
            <AppBar position="fixed" open={true}>
                <Toolbar sx={{justifyContent: "space-between"}}>
                    Habilitação do responsável técnico
                    <div className={propStyles.dropdown}>
                        <button
                            aria-haspopup="true"
                            className={propStyles.avatarButton}
                            onClick={handleClickMenu}
                        >
                            <FontAwesomeIcon icon={faUserTie} size="2x" /> 
                        </button>
                        <Menu 
                            open={openMenu} 
                            sx={{"& .MuiPaper-root": {
                                backgroundColor: "#494949",
                                color: "white"
                            }}} 
                            anchorEl={anchorEl} 
                            onClose={handleCloseMenu} 
                        >
                            <MenuItem  onClick={onClickLogout} >Logout</MenuItem>
                        </Menu>
                        <button
                            aria-haspopup="true"
                            className={propStyles.avatarButton}
                            onClick={handleClickManual}
                        >
                            <Tooltip title="Manual do sistema">
                                <FontAwesomeIcon icon={faQuestion} size="2x" /> 
                            </Tooltip>
                        </button>
                    </div>
                </Toolbar>
            </AppBar>
            <Drawer open={true} variant="permanent">
                <DrawerHeader>
                    <div style={{ width: "250px" }} className={propStyles.drawerLogo}>
                        <div className={propStyles.logoFull}>
                            <img src={logoA} alt="Logo cooperativa" />
                        </div>
                    </div>
                </DrawerHeader>
                <Box sx={{ display: "flex", justifyContent: "center", flexDirection: "column", gap: "10px", padding: "9px" }}>
                    <DrawerButtonThatOpens open={true} name="" disabled={true}>
                            <MenuIcon />
                        </DrawerButtonThatOpens>
                        <DrawerButtonThatOpens open={true} name="Equipamentos" disabled={true}>
                            <FontAwesomeIcon icon={faBoxOpen} />
                        </DrawerButtonThatOpens>
                        <DrawerButtonThatOpens open={true} name="Orçamento estimado" disabled={true}>
                            <FontAwesomeIcon icon={faFileCircleCheck} />
                        </DrawerButtonThatOpens>
                        <DrawerButtonThatOpens open={true} name="Orçamento de conexão" disabled={true}>
                            <FontAwesomeIcon icon={faFileSignature} />
                        </DrawerButtonThatOpens>
                        <DrawerButtonThatOpens open={true} name="Solicitação de vistoria" disabled={true}>
                            <FontAwesomeIcon icon={faFileWaveform} />
                    </DrawerButtonThatOpens>
                </Box>
            </Drawer>
            <div className={`${propStyles.corfundo} ${propStyles.divgeral}`}>
                    <div className={propStyles.fcLeftImage}>
                        <img src={ImagemLateralE} alt="Mundo com duas pessoas" />
                    </div>
                    <div className={propStyles.fcCenterContent}>
                        <h1>Revisão</h1>
                        <p>Antes de analisarmos o seu cadastro precisamos de mais alguns documentos.<FontAwesomeIcon title="O documento profissional é um documento que habilita o profissional para a elaboração de projetos elétricos, podendo ser o CREA ou outros documentos." style={{ marginLeft: "10px", width: "15px", height: "15px", cursor: "pointer"}} icon={faQuestionCircle} /></p>
                        <form onSubmit={onClickSalvarCad}>
                            <div className={propStyles.fcCenterImages}>
                                <div>
                                    <ImageInput name="Doc. profissional (frente)" register={register} registerName="frenteCrea" imageLoaded={creaFrenteAux} nomeArquivo={nomeCreaFrenteAux} />
                                </div>
                                <div>
                                    <ImageInput name="Doc. profissional (verso)" register={register} registerName="versoCrea" imageLoaded={creaVersoAux} nomeArquivo={nomeCreaVersoAux} />
                                </div>
                                <div>
                                    <ImageInput name="Selfie c/ identidade" register={register} registerName="selfie" imageLoaded={fotoPessoalAux} nomeArquivo={nomeFotoPessoalAux} />
                                </div>
                            </div>
                            <div className={propStyles.fcFormFields}>
                                <FormControl variant="outlined" style={{ width: '230px' }}>
                                    <InputLabel htmlFor="cadastro-datavalidadecrea" shrink style={{ color: "#b8b8b8", zIndex: 0}}>
                                        Data de validade do documento
                                    </InputLabel>
                                    <Controller 
                                        name="dataValidadeCrea"
                                        control={control}
                                        render={({ field }) => (
                                            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR}>
                                                <DatePicker 
                                                    {...field}
                                                    error={!!errors.dataValidadeCrea}
                                                    inputFormat="dd/MM/yyyy"
                                                    label="Data de validade do documento"
                                                    renderInput={({ inputRef, inputProps, InputProps }) => (
                                                        <>
                                                            <WhiteInput ref={inputRef}  {...inputProps} sx={{color: "#fff"}} className={`${errors?.dataValidadeCrea ? propStyles.campoComValorErrado : ""}`}  placeholder="__/__/____"/>
                                                            <span style={{ position: "absolute", top: 38, right: 15, color: "white", svg: "white", input: "white", label: "white" }}>
                                                                {InputProps?.endAdornment}
                                                            </span>
                                                        </>
                                                    )}
                                                />
                                            </LocalizationProvider>
                                        )}
                                    />
                                    { errors?.dataValidadeCrea ?  (
                                        <HelperText text={errors?.dataValidadeCrea?.message} />
                                    ) : '' }
                                </FormControl>
                            </div>
                            <div className={propStyles.fcFormFields}>
                                <Controller
                                    name="empresa"
                                    control={control}
                                    render={({field}) => (
                                        <FormControl variant="outlined" sx={{ width: "49%" }}>
                                            <InputLabel htmlFor="cadastro-empresa" shrink style={{ color: "#C8C8C8"}}>Empresa vinculada</InputLabel>
                                            <WhiteInput 
                                                fullWidth
                                                placeholder="Empresa Ltda."
                                                id="cadastro-empresa"
                                                error={!!errors.empresa}
                                                {...field}
                                                className={`${errors?.empresa ? propStyles.campoComValorErrado : ""}`}
                                            />
                                            { errors?.empresa ?  (
                                                <HelperText text={errors?.empresa?.message} />
                                            ) : '' }
                                        </FormControl>
                                    )}
                                />
                                <Controller
                                    name="creadoc"
                                    control={control}
                                    render={({field}) => (
                                        <FormControl variant="outlined" sx={{ width: "49%" }}>
                                            <InputLabel htmlFor="cadastro-creadoc" shrink style={{ color: "#C8C8C8" }}>Nº doc. profissional</InputLabel>
                                            <WhiteInput 
                                                fullWidth
                                                placeholder="000000000000000"
                                                id="cadastro-creadoc"
                                                error={!!errors.creadoc}
                                                {...field}
                                                className={`${errors?.creadoc ? propStyles.campoComValorErrado : ""}`}
                                            />
                                            { errors?.creadoc ?  (
                                                <HelperText text={errors?.creadoc?.message} />
                                            ) : '' }
                                        </FormControl>
                                    )}
                                />
                                    <>
                                        <Controller
                                            name="nome"
                                            control={control}
                                            render={({field}) => (
                                                <FormControl variant="outlined" sx={{ width: "49%" }}>
                                                    <InputLabel htmlFor="cadastro-nome" shrink style={{ color: "#C8C8C8"}}>Nome completo</InputLabel>
                                                    <WhiteInput 
                                                        fullWidth
                                                        placeholder="Nome"
                                                        id="cadastro-nome"
                                                        error={!!errors.nome}
                                                        {...field}
                                                        className={`${errors?.nome ? propStyles.campoComValorErrado : ""}`}
                                                    />
                                                    { errors?.nome ?  (
                                                        <HelperText text={errors?.nome?.message} />
                                                    ) : '' }
                                                </FormControl>
                                            )}
                                        />
                                        <Controller
                                            name="email"
                                            control={control}
                                            render={({field}) => (
                                                <FormControl variant="outlined" sx={{ width: "49%" }}>
                                                    <InputLabel htmlFor="cadastro-email" shrink style={{ color: "#C8C8C8" }}>E-mail</InputLabel>
                                                    <WhiteInput 
                                                        fullWidth
                                                        type="email"
                                                        placeholder="E-mail"
                                                        id="cadastro-email"
                                                        error={!!errors.email}
                                                        {...field}
                                                        className={`${errors?.email ? propStyles.campoComValorErrado : ""}`}
                                                    />
                                                    { errors?.email ?  (
                                                        <HelperText text={errors?.email?.message} />
                                                    ) : '' }
                                                </FormControl>
                                            )}
                                        />
                                        <Controller 
                                            name="celular"
                                            control={control}
                                            render={({field: {onChange, value}}) => (
                                                <FormControl variant="outlined" sx={{ width: "49%" }}>
                                                    <InputLabel htmlFor="cadastro-celular" shrink style={{ color: "#C8C8C8"}}>Celular</InputLabel>
                                                    <InputMask
                                                        mask="(99) 99999-9999"
                                                        onChange={onChange}
                                                        value={value}
                                                        id="cadastro-celular"
                                                    >
                                                        {inputProps => (
                                                            <WhiteInput 
                                                                fullWidth
                                                                error={errors?.celular?.message}
                                                                {...inputProps}
                                                                className={`${errors?.celular ? propStyles.campoComValorErrado : ""}`}
                                                            />
                                                        )}
                                                    </InputMask>
                                                    { errors?.celular ?  (
                                                        <HelperText text={errors?.celular?.message} />
                                                    ) : '' }
                                                </FormControl>
                                            )}
                                        />
                                        <Controller 
                                            name="cpf"
                                            control={control}
                                            render={({field: {onChange, value}}) => (
                                                <FormControl variant="outlined" sx={{ width: "49%" }}>
                                                    <InputLabel htmlFor="cadastro-cpf" shrink style={{ color: "#C8C8C8" }}>CPF</InputLabel>
                                                    <InputMask 
                                                        mask="999.999.999-99"
                                                        id="cadastro-cpf"
                                                        onChange={onChange}
                                                        value={value}
                                                    >
                                                        {inputProps => (
                                                            <WhiteInput 
                                                                fullWidth
                                                                error={errors?.cpf?.message}
                                                                {...inputProps}
                                                                className={`${errors?.cpf ? propStyles.campoComValorErrado : ""}`}
                                                            />
                                                        )}
                                                    </InputMask>
                                                    { errors?.cpf ?  (
                                                        <HelperText text={errors?.cpf?.message} />
                                                    ) : '' }
                                                </FormControl>
                                            )}
                                        />
                                    </>
                            </div>
                            <p>Fique atento aos meios de comunicação que você informou aqui (e-mail e telefone). Assim que a solicitação de habilitação for analisada enviaremos um e-mail de confirmação.</p>
                            <p>Após a solicitação de revisão do cadastro de habilitação, você possui o prazo de <b>{prazoAnaliseCadRespTec} dias</b> para revisar o seu cadastro e solicitar uma nova análise.</p>
                            <div className={propStyles.fcFormButtons}>
                                <BlueHoverButton variant="contained" onClick={onClickSalvarCad}>Salvar</BlueHoverButton>
                                <BlueHoverButton variant="contained" onClick={onClickSolicitarNovaAnalise}>Enviar para análise</BlueHoverButton>
                            </div>
                        </form>
                    </div>
                    <div className={propStyles.fcRightImage}>
                        <img src={ImagemLateralD} alt="Mundo com duas pessoas" />
                    </div>
            </div>
            <Snackbar open={openSuccess} anchorOrigin={{ vertical: 'top', horizontal: 'center' }} autoHideDuration={6000} onClose={handleCloseSuccess}> 
                    <Alert onClose={handleCloseSuccess} severity="success" sx={{ width: '100%' }}>
                        {successMessage}
                    </Alert>
            </Snackbar>
            <Snackbar open={open} anchorOrigin={{ vertical: 'top', horizontal: 'center' }} autoHideDuration={6000} onClose={handleClose}> 
                    <Alert onClose={handleClose} severity="error" sx={{ width: '100%' }}>
                        {errorMessage}
                    </Alert>
            </Snackbar>
            <Modal open={isLoading}>
                <Box style={modalStyle}>
                    <CircularProgress color="inherit" />
                </Box>
            </Modal>
            <Modal open={openRevisao}>
                <Box style={ModalStyle}>
                    <h2 className={propStyles.modalTitulo}>Itens para Revisar</h2>
                    <div className={propStyles.modalConteudo}>
                        <div>
                            <p>{revisao}</p>
                        </div>
                    </div>
                    <div className={propStyles.modalBotao}>
                        <BlueHoverButton onClick={handleCloseRevisao} >
                            Continuar
                        </BlueHoverButton>
                    </div>
                </Box>
            </Modal>
        </Box>
    );
}

export { RevisarCadastro };